export default class AbortRequestError extends Error {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    constructor({ _requestId, _canceled, ...response }) {
        super('Request canceled');
        Object.defineProperty(this, "response", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = 'AbortError';
        this.response = response;
    }
    getResponse() {
        return this.response;
    }
}
